import { rootMargin } from '@helpers/animate';
import { getSrcs, imageUrl } from '@helpers/image';
import { Device, until } from '@helpers/media';
import { useInView } from '@hooks/useInView';
import SvgWave from '@img/branding-graphics/wave-generic2.svg';
import { LinkButton } from '@stories/Components/Buttons/GeneralButton/Button';
import * as React from 'react';
import S from './SignpostSplitContent.styles';
const SignpostSplitContent = (props) => {
    const [ref, inView] = useInView({ rootMargin }, false, props.pageContext?.isEditMode);
    const imageWidth = 564;
    const imageRatio = 237 / 339;
    const srcs = props.image ? getSrcs(props.image, imageWidth, 339, 5, imageRatio) : [];
    const sizes = `${until(Device.MobileLarge)} 100vw, ${until(Device.Desktop)} 40vw, ${until(Device.DesktopLarge)} 36vw, 597px`;
    return (React.createElement(S.Container, { ref: ref, "data-animate": inView, "data-bg-graphic": !!props.containerGraphic, "data-content-variant": props.variant ?? 'dark', "data-use-bg": props.useContainerBg ? 'bg' : 'nobg', removeSkipLink: true },
        props.containerGraphic && React.createElement(SvgWave, null),
        React.createElement(S.ContentWrapper, { "data-variant": props.variant ?? 'dark' },
            React.createElement(S.ContentContainer, null,
                props.title && React.createElement(S.Title, null, props.title),
                props.content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } }),
                props.cta && (React.createElement(LinkButton, { branding: "solid", href: props.cta.url, target: props.cta.target, title: props.cta.text ?? `Learn More` }))),
            props.image ? (React.createElement(S.ImageWrapper, { "data-align": props.imageAlignment },
                React.createElement(S.ImageContainer, null,
                    React.createElement(S.Image, { src: srcs[0].split(' ')[0], srcSet: srcs.join(','), sizes: sizes, alt: props.image.altText ?? props.title })))) : null,
            props.video ? (React.createElement(S.ImageWrapper, { "data-align": props.imageAlignment },
                React.createElement(S.ImageContainer, null,
                    React.createElement(S.Image, { as: "video", autoPlay: true, loop: true, muted: true, playsInline: true, poster: imageUrl(props.video.previewImage, {
                            width: imageWidth,
                            height: imageRatio * imageWidth,
                        }) },
                        React.createElement("source", { src: props.video.src, type: "video/mp4" }))))) : null)));
};
export default SignpostSplitContent;
